// frontend/src/components/content/DiscussionPostItem.js (فایل جدید)

import React, { useState } from 'react';
import { FaUserCircle, FaReply } from 'react-icons/fa';
import PostForm from './PostForm';

// کامپوننت آواتار ساده
const Avatar = ({ user }) => {
    const name = user?.full_name || user?.username || "کاربر";
    const initial = name ? name.charAt(0) : '?';
    return <div className="avatar" style={{width: '40px', height: '40px'}}>{initial}</div>;
};

const DiscussionPostItem = ({ post, lessonId, onReplySuccess }) => {
    const [showReplyForm, setShowReplyForm] = useState(false);

    // تابعی برای رفرش کردن پس از ارسال پاسخ
    const handleReply = () => {
        setShowReplyForm(false); // بستن فرم پاسخ
        onReplySuccess(); // رفرش کل تالار
    };

    return (
        <div className="discussion-post">
            <div className="post-header">
                <Avatar user={post.author} />
                <div className="post-author-info">
                    <strong>{post.author?.full_name || post.author?.username || "کاربر حذف شده"}</strong>
                    <span className="post-date">
                        {new Date(post.created_at).toLocaleString('fa-IR')}
                    </span>
                </div>
            </div>
            <div className="post-content">
                <p>{post.content}</p>
            </div>
            <div className="post-actions">
                <button onClick={() => setShowReplyForm(!showReplyForm)} className="button-reply">
                    <FaReply /> {showReplyForm ? 'انصراف' : 'پاسخ'}
                </button>
            </div>

            {/* فرم پاسخ (در صورت کلیک) */}
            {showReplyForm && (
                <div className="reply-form-container">
                    <PostForm
                        lessonId={lessonId}
                        parentId={post.id} // ID این پست به عنوان والد
                        buttonText="ارسال پاسخ"
                        onSuccess={handleReply}
                    />
                </div>
            )}

            {/* نمایش پاسخ‌های تودرتو (Recursive) */}
            {post.replies && post.replies.length > 0 && (
                <div className="replies-container">
                    {post.replies.map(reply => (
                        <DiscussionPostItem
                            key={reply.id}
                            post={reply}
                            lessonId={lessonId}
                            onReplySuccess={onReplySuccess} // تابع رفرش را به فرزندان هم پاس بده
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default DiscussionPostItem;